import { EventTrack } from '../dtos/event-track'

export const makeTrackingEventData = (data: EventTrack) => ({
  userId: data.userId,
  userEmail: data.userEmail,
  telegramId: data.telegramId,
  whatsappId: data.whatsappId,
})
